import { useState } from "react";
import { toast } from "sonner";
import API, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { SignaturePad } from "../SignaturePad";
import { Signature } from "@phosphor-icons/react";

/** Engineer confirms a toolbox talk with a finger signature on their phone — required, stored on the talk record. */
export function TalkSignDialog({ talk, onClose, onSigned }) {
  const [sig, setSig] = useState("");
  const [busy, setBusy] = useState(false);
  const sign = async () => {
    if (!sig) { toast.error("Sign on the screen first"); return; }
    setBusy(true);
    try { const { data } = await API.post(`/hs/toolbox-talks/${talk.id}/acknowledge`, { signature: sig }); toast.success(data.message); onSigned?.(); onClose(); setSig(""); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't record your signature"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!talk} onOpenChange={(o) => { if (!o) { onClose(); setSig(""); } }}>
      <DialogContent className="max-w-md" data-testid="talk-sign-dialog">
        <DialogHeader>
          <DialogTitle className="font-[Chivo] flex items-center gap-2"><Signature size={18} /> Sign to confirm</DialogTitle>
          <DialogDescription>“{talk?.title}” — by signing you confirm you attended, read the talk and understood what you must do.</DialogDescription>
        </DialogHeader>
        <div data-testid="talk-sign-pad"><SignaturePad value={sig} onChange={setSig} height={160} /></div>
        <p className="text-[11px] text-muted-foreground">Draw your signature with your finger. Your name, the date and time are recorded with it.</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={sign} disabled={busy || !sig} className="min-h-[44px]" data-testid="talk-sign-confirm"><Signature size={16} className="mr-1" /> {busy ? "Saving…" : "I've read & understood — sign"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
